var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: _vm.$t("common.reset"),
          expression: "$t('common.reset')",
        },
      ],
      staticClass:
        "w-6 h-6 rounded flex justify-center items-center transform transition hover:bg-gray-100 hover:rotate-180",
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("img", {
        staticClass: "w-4 h-4",
        attrs: { src: require("@/assets/images/reset.svg"), alt: "reset" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }